import {Component, Inject, OnInit, QueryList, ViewChild, ViewChildren,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectControlItemService,
  ProjectService, TenantService,
  UserService,
} from '../../_services/index';

import {Project, ProjectControlItem, User} from '../../_models/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";


import {DatesHelper, ImplementationStatus, LoginHelper, Recurring, Role, StringsHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from "moment";
import {IndexConfigService} from "../../_services/index.config.service";
import {SelectItem} from "primeng/api";
import {fromByteArray} from "base64-js";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {CompletionPeriod} from "../../_models/completion-period";
import {saveAs as importedSaveAs} from "file-saver";
import {Policy} from "../../_models/policy";
import {PolicyService} from "../../_services/policy.service";
import {forkJoin} from "rxjs";
import {ProjectControlItemComponent} from "../projectControlItem";
import {ProjectAccessRightsComponent} from "../projectAccessRights/project.access.rights.component";
import {MessageComponent} from "../message";
import {GenerateSspComponent} from "../generateSsp/generateSsp.component";
import {ProjectPropertiesComponent} from "../projectProperties";
import {Constants} from "../../helpers/constants";
import {ScoringReportComponent} from "../scoringReport/scoringReport.component";
import {EvidenceRecurring} from "../../helpers/evidenceRecurring";
import {GenerateCrmComponent} from "../generateCrm/generateCrm.component";
import {Table} from "primeng/table";
import {
  SendProjectControlItemMessageComponent
} from "../sendProjectControlItemMessage/send-project-control-item-message.component";

@Component({
  standalone: false,
  selector: "project-new-component",
  templateUrl: 'projectNew.component.html',
  styleUrls: ['./projectNew.component.scss'],
})

export class ProjectNewComponent implements OnInit {
  @ViewChild('table') table;
  projectId: number;
  project: Project;
  selectedItem: ProjectControlItem;
  projectControlItems: ProjectControlItem[];
  filteredProjectControlItems: ProjectControlItem[];
  remainingControlItems: ProjectControlItem[];
  filteredControlItems: any;
  initialprojectControlItemId: number;
  clients: User[];
  assignedVendorUsers: User[];
  assignedNonVendorUsers: User[];
  rowGroupMetadata = {};
  currentUser: User;
  isVendor = false;
  userMap = {};
  policies: Policy[];
  expandedStatus = {};
  expandedItem = {};
  expandedSmallItem = {};
  expandedDetails = {};
  canEditProject: boolean;
  userToken = LoginHelper.getFileToken();
  constants: any = Constants.DefaultApiHost;
  timeout: any;
  window = window;
  filter: string = "";
  dotsExpanded = true;
  initialImplementationStatus: number;
  expandedCategories = {};
  isRizkMapEnabled = false;
  isSspEnabled = false;

  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Partially Implemented",
      3: "Planned",
      4: "Alternative Implementation",
      5: "Not Applicable",
      7: "Not Implemented"
      //6: "Ongoing",
    };

  actionItemStatuses: any =
    {
      0: "Not Started",
      1: "In-Progress",
      2: "Resolved",
      3: "Awaiting Review",
      4: "Reviewed - Not POAM"
    };

  assessmentNoteStatuses: any =
    {
      0: "Open",
      1: "In-Progress",
      2: "Addressed",
    };


  implementationStatusFilterOptions: SelectItem[] =
    [
      {label: "None", value: "None"},
      {label: "Implemented", value: "Implemented"},
      {label: "Partially Implemented", value: "Partially Implemented"},
      {label: "Planned", value: "Planned"},
      {label: "Alternative Implementation", value: "Alternative Implementation"},
      {label: "Not Applicable", value: "Not Applicable"},
      {label: "Not Implemented", value: "Not Implemented"}
      //{label: "Ongoing", value: 6},
    ];

  booleanFilterOptions = [
    {label: "Yes", value: true},
    {label: "No", value: false},
  ];

  recurringList: any[];
  categoryFilterOptions = [];
  anyAreaWithLevels = false;
  anyAreaWithFedRamp = false;
  cols : any[] = [
    {'field': 'controlItem.category', 'header': 'Category', width: '20%'},
    {'field': 'controlItem.complianceAreaControlId', 'header': 'ID', width: '10em'},
    {'field': 'responsibility', 'header': 'Responsibility', width: '14em'},
    {'field': 'controlItem.shortName', 'header': 'Name', width: '20%'},
    {'field': 'parentName', 'header': 'Parent', width: '10%'},
    {'field': 'controlItem.level', 'header': 'Level', width: '8em'},
    {'field': 'priority', 'header': 'Priority', width: '10em'},
    {'field': 'assignedClient.userId', 'header': 'Owner', width: '10%'},
    {'field': 'mapping', 'header': 'Source Control', width: '10%'},
    {'field': 'targetMapping', 'header': 'Target Control', width: '10%'},
    {'field': 'implementationStatusText', 'header': 'Status', width: '8em'},
    {'field': 'dueDate', 'header': 'Due', width: '7em'},
    {'field': 'recurring', 'header': 'Freq', width: '8em'},
    {'field': 'currentRangeCompleted', 'header': 'Compl', width: '8em'},
    {'field': 'reviewRequired', 'header': 'Review Requested', width: '16em'},
    {'field': 'riskNumber', 'header': 'Risks', width: '7em'},
    {'field': 'classification', 'header': 'Classification', width: '7em'},
    {'field': 'score', 'header': 'Score', width: '7em'},
    {'field': 'cr', 'header': 'CR', width: '5em'},
    {'field': 'assessmentActive', 'header': 'Assessment Active', width: '12em'},
    {'field': 'lastModifiedDate', 'header': 'Last Modified', width: '14em'},
    {'field': 'controlType_', 'header': 'Control Type', width: '14em'},
    {'field': 'dynamicScore', 'header': 'Dynamic Score', width: '7em'},
  ]

  minReviewedDate = moment().add(-7, 'day').format('YYYY-MM-DD:00:00:00');
  columnOptions: SelectItem[];
  columnVisibility: any = {
    'controlItem.level': false,
    'mapping': false,
    'targetMapping': false,
    'currentRangeCompleted': false,
    'reviewRequired': false,
  };
  isUserAdvisor = false;
  visibleColumns = 16;
  settings: any;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public projectService: ProjectService,
    public projectControlItemService: ProjectControlItemService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public policyService: PolicyService,
    public fileBlobService: FileBlobService,
    public userService: UserService,
    public clientProfileService: ClientProfileService,
    public dialog: MatDialog,
    public tenantService: TenantService,
    @Inject(DOCUMENT) public document: any,
    public config: IndexConfigService) {
    this.projectId = route.snapshot.params['projectId'];
    window.localStorage.setItem('LastProjectVisited', this.projectId.toString(10));
    this.initialImplementationStatus = route.snapshot.params['implementationStatus'];
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isVendor = this.currentUser.role == Role.Vendor;
    this.isUserAdvisor = (this.currentUser.role & (Role.AdvisorStaff | Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != null;
    this.canEditProject = (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0
      || (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;

    this.categoryFilterOptions = [];

    this.tenantService.getCurrent().subscribe(t => {
      this.isRizkMapEnabled = t.isRizkMapEnabled;
      this.isSspEnabled = t.isSspEnabled;
    });

    this.loadProject();

    this.userService.getAllShort().subscribe(users => {
      //this.users = users;
      users.forEach(u => this.userMap[u.userId] = u);
    });

    this.route.params.subscribe(p => {
      if (p["projectControlItemId"]) {
        this.initialprojectControlItemId = p["projectControlItemId"];
      }
    })
  }

  loadProject() {
    const requests = [this.projectService.getById(this.projectId)];
    requests.push(this.clientProfileService.getUserSetting('ProjectTableNew'))
    requests.push(this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()))

    if (!this.policies) {
      requests.push(this.policyService.getAllPolicys());
    }
    forkJoin(requests).subscribe(
      (data: any[]) => {
        this.project = data[0];
        this.settings = data[2];
        if (data.length > 2) {
          this.policies = data[3] || [];
        }

        this.columnVisibility = (data[1] || {}).columnVisibility || this.columnVisibility;
        this.columnOptions = [];
        for (let i = 0; i < this.cols.length; i++) {
          this.columnOptions.push({label: this.cols[i].header, value: this.cols[i]});
        }
        this.cols = this.cols.filter(col => this.columnVisibility[col.field] !== false);
        this.filteredProjectControlItems = this.projectControlItems = this.project.projectControlItems.filter(i => !this.project.deniedUserCategoriesMap[this.currentUser.userId] || this.project.deniedUserCategoriesMap[this.currentUser.userId].indexOf(i.controlItem.category) < 0);

        this.projectControlItems.forEach(projectControlItem => {
          let i;
          this.anyAreaWithLevels = this.anyAreaWithLevels || projectControlItem.controlItem.complianceArea.hasLevels;
          this.anyAreaWithFedRamp = this.anyAreaWithFedRamp || projectControlItem.controlItem.complianceArea.isFedRamp;
          const parent = this.projectControlItems.find(i => i.controlItem.controlItemId == projectControlItem.controlItem.parentControlItemId);
          if (parent) {
            (<any>projectControlItem).parentName = parent.controlItem.category + ' - ' + parent.controlItem.complianceAreaControlId;
          }
          (<any>projectControlItem).policies = projectControlItem.projectControlItemPolicies && projectControlItem.projectControlItemPolicies.length > 0 ? projectControlItem.projectControlItemPolicies.map(projectControlItemPolicy => this.policies.find(p => projectControlItemPolicy.policyId == p.id)).filter(i => i) : [];
          (<any>projectControlItem).implementationStatusText = this.implementationStatuses[projectControlItem.implementationStatus];
          projectControlItem.assignedClient.fullName = projectControlItem.assignedClient.firstName + " " + projectControlItem.assignedClient.lastName;
          this.updateScore(projectControlItem);
          projectControlItem.subItems = this.projectControlItems.filter(i => i.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId && (!this.project.isPartner || i.assignedClientId == projectControlItem.assignedClientId))
            .sort((a, b) =>
              a.controlItem.level > b.controlItem.level ? 1 : a.controlItem.level < b.controlItem.level ? -1 :
                a.controlItem.complianceAreaControlId > b.controlItem.complianceAreaControlId ? 1 : -1);
          projectControlItem.subItemLevels = [];
          (<any>projectControlItem).implementationStatusStyle = (projectControlItem.implementationControlStatusNotNeeded || projectControlItem.implementationStatus == ImplementationStatus.Implemented || projectControlItem.implementationStatus == ImplementationStatus.AlternativeImplementation) ? 'green' :
            (projectControlItem.implementationStatus == ImplementationStatus.PartiallyImplemented || projectControlItem.implementationStatus == ImplementationStatus.Planned) ? 'yellow' :
              projectControlItem.implementationStatus == ImplementationStatus.NotApplicable ? 'gray' : 'red';
          (<any>projectControlItem).evidencesStyle = projectControlItem.evidenceNotNeeded ? 'gray' :
            (projectControlItem.evidences && projectControlItem.evidences.length && (projectControlItem.evidenceFrequency == EvidenceRecurring.None || projectControlItem.evidenceFrequency == EvidenceRecurring.OneTime))
            || (projectControlItem.evidenceFrequency > EvidenceRecurring.OneTime
              && projectControlItem.evidences.find(e =>
                moment(e.date).isSameOrAfter(moment().add(-1,
                  projectControlItem.evidenceFrequency == EvidenceRecurring.Daily ? 'day' :
                    projectControlItem.evidenceFrequency == EvidenceRecurring.Weekly ? 'week' :
                      projectControlItem.evidenceFrequency == EvidenceRecurring.Monthly ? 'month' :
                        projectControlItem.evidenceFrequency == EvidenceRecurring.Quarterly ? 'quarter' : 'year')))) ? 'green' : 'red';
          (<any>projectControlItem).gapStyle = projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'High') ? 'red' :
            projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'Medium') ? 'orangestatus' :
              projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'Low') ? 'yellow' : 'gray';
          (<any>projectControlItem).gapCount = projectControlItem.actionPlans.filter(a => a.currentStatus != 2 && a.riskLevel).length.toString(10);
          let currentLevel = "";
          for (i = 0; i < projectControlItem.subItems.length; i++) {
            projectControlItem.subItems[i].hasParent = true;
            if (projectControlItem.subItems[i].controlItem.level != currentLevel) {
              currentLevel = projectControlItem.subItems[i].controlItem.level;
              const newSubItemLevel = {subItems: [], level: currentLevel};
              projectControlItem.subItemLevels.push(newSubItemLevel);
            }
            projectControlItem.subItemLevels[projectControlItem.subItemLevels.length - 1].subItems.push(projectControlItem.subItems[i]);
          }
          projectControlItem.upcomingDueDate = this.getUpcomingDate(projectControlItem).format('Y-MM-DDT00:00:00');
          projectControlItem.previousDueDate = this.getPreviousDate(projectControlItem).format('Y-MM-DDT00:00:00');
          /*var currentRange = projectControlItem.completionPeriods.filter(a => moment(a.dueDate).isAfter(moment())).sort((a, b) => moment(a.dueDate).isAfter(b.dueDate))[0];
          if (!currentRange){
            currentRange = projectControlItem.completionPeriods.filter(a => moment(a.dueDate).isSameOrBefore(moment())).sort((a, b) => moment(a.dueDate).isBefore(b.dueDate))[0] || {isCompleted: false};
          }*/
          projectControlItem.currentRangeCompleted = (projectControlItem.completionPeriods.find(i => moment(i.dueDate + 'Z').isSame(projectControlItem.upcomingDueDate + 'Z')) || {isCompleted: false}).isCompleted;


          projectControlItem.originalCompletionPeriods = JSON.parse(JSON.stringify(projectControlItem.completionPeriods));
          projectControlItem.originalreviewedByConsultantDates = Object.assign([], projectControlItem.reviewedByConsultantDates);

          this.clients = this.project.assignedUsers;
          this.clients.forEach(u => u.fullName = StringsHelper.getFullName(u));
          this.assignedVendorUsers = this.project.assignedUsers.filter(u => u.role == Role.Vendor);
          this.assignedNonVendorUsers = this.project.assignedUsers.filter(u => u.role != Role.Vendor);

          if (!projectControlItem.attachments) {
            projectControlItem.attachments = [];
          } else {
            projectControlItem.attachments.forEach(a => {
              if (a.name.indexOf('document://') == 0) {
                (<any>a).fileName = a.name.split('\\').pop();
                let path = a.name.match(/^document:\/\/(.*)\\[^\\]*$/i)[1] || "";
                path = path === 'null' ? '\\' : path;
                (<any>a).url = this.config.api + '/api/attachments/file?token=' + LoginHelper.getFileToken() + '&name=' + encodeURIComponent((<any>a).fileName) + "&path=" + encodeURIComponent(path);
              }
            })
          }
          const controlOriginationQuestions = (projectControlItem.controlItem.controlOrigination || '').split('\n').map(q => q.replace('☐', '').trim()).filter(q => q);
          let oldValueParts = [];
          try {
            oldValueParts = JSON.parse(projectControlItem.controlOrigination || '[]');
          } catch (e) {
          }
          const controlOrigination = controlOriginationQuestions.map((q, i) => oldValueParts[i] || false);
          let isCr = !!controlOriginationQuestions.find((q, i) => controlOrigination[i] && q.toLowerCase().indexOf('customer') >= 0);
          let isParentCr = false;

          if (parent) {
            const parentControlOriginationQuestions = (parent.controlItem.controlOrigination || '').split('\n').map(q => q.replace('☐', '').trim()).filter(q => q);
            oldValueParts = [];
            try {
              oldValueParts = JSON.parse(parent.controlOrigination || '[]');
            } catch (e) {
            }
            const parentControlOrigination = parentControlOriginationQuestions.map((q, i) => oldValueParts[i] || false);
            isParentCr = !!parentControlOriginationQuestions.find((q, i) => parentControlOrigination[i] && q.toLowerCase().indexOf('customer') >= 0);
          }

          (<any>projectControlItem).cr = isCr || isParentCr ? 'Yes' : 'No';
        });

        this.visibleColumns = this.cols.filter(c => (c.field != 'parentName' || (this.project && this.project.displayParentRows)) && (c.field != 'controlItem.level' || this.anyAreaWithLevels) && (c.field != 'controlType_' || this.anyAreaWithFedRamp)).length;

        for (let controlItem of this.filteredProjectControlItems) {
          let status = 'gray'; // Default status
          let redCount = 0, greenCount = 0, orangeCount = 0;

          // Check the main workstream items
          if (Array.isArray(controlItem.workstreamItems)) {
            for (let workstreamItem of controlItem.workstreamItems) {
              const isItemOverdue = this.isItemOverdue(workstreamItem);
              const currentStatus = workstreamItem.status;

              if (isItemOverdue) {
                redCount++;
                continue;
              }

              if (currentStatus !== 'Dev Complete' && currentStatus !== 'Deployed') {
                orangeCount++;
              } else if (status === 'gray') {
                greenCount++;
              }
            }
          }

          for (let subItem of controlItem.subItems) {
            if (Array.isArray(subItem.workstreamItems)) {
              let subItemStatus = 'gray'; // Default status for subItem

              for (let workstreamItem of subItem.workstreamItems) {
                const isItemOverdue = this.isItemOverdue(workstreamItem);
                const currentStatus = workstreamItem.status;

                if (isItemOverdue) {
                  subItemStatus = 'red';
                  redCount++;
                  continue;
                }

                if (currentStatus !== 'Dev Complete' && currentStatus !== 'Deployed') {
                  orangeCount++
                } else if (subItemStatus === 'gray') {
                  greenCount++;
                }
              }
            }
          }

          status = 'gray';
          if(redCount > 0) {
            status = 'red';
          } else if(orangeCount > 0) {
            status = 'orange';
          } else if(greenCount > 0) {
            status = 'green';
          }

          controlItem.workstreamStatus = status;
          controlItem.redCount = redCount;
          controlItem.greenCount = greenCount;
          controlItem.orangeCount = orangeCount;
        }

        this.regroupControlItems();
        if (this.initialImplementationStatus != null) {

          setTimeout(() =>
            this.table.filter([this.implementationStatusFilterOptions[this.initialImplementationStatus].value], 'implementationStatusText', 'in'), 500);
        }

        if (this.initialprojectControlItemId > 0) {
          const item = this.projectControlItems.find(i => i.projectControlItemId == this.initialprojectControlItemId);
          const parent = item.controlItem.parentControlItemId ? this.projectControlItems.find(i => i.controlItem.controlItemId == item.controlItem.parentControlItemId) : null;
          this.editControlItem(this.initialprojectControlItemId, parent);
        }
      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });
  }

  public getUpcomingDate(projectControlItem): moment.Moment {
    const ranges = DatesHelper.getDates(projectControlItem);
    const now = moment().startOf('day').add(15, 'hour');
    const closest = ranges.reverse().find(i => i.date.isSameOrAfter(now, 'day') && !projectControlItem.completionPeriods.find(d => d.isCompleted && moment(d.dueDate).isSame(i.value + "Z")));
    return (closest || ranges[0]).date;
  }

  public getPreviousDate(projectControlItem): moment.Moment {
    const ranges = DatesHelper.getDates(projectControlItem).reverse();
    const now = moment().startOf('day').add(15, 'hour');
    const upcomingNum = ranges.indexOf(ranges.find(i => i.date.isSameOrAfter(now, 'day') && !projectControlItem.completionPeriods.find(d => d.isCompleted && moment(d.dueDate).isSame(i.value + "Z"))));
    if (upcomingNum <= 0) return moment().add(-1, 'day');
    const previous = ranges[upcomingNum - 1];
    return previous.date;
  }

  regroupControlItems() {
    let i;
    this.filteredControlItems = {};
    this.remainingControlItems = [...this.filteredProjectControlItems/*.filter(i => !i.controlItem.parentControlItemId || this.filteredProjectControlItems.find(c => c.controlItem.controlItemId == i.controlItem.parentControlItemId))*/];
    if (this.assignedVendorUsers.length == 0) {
      this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
      return;
    }
    for (const item of this.filteredProjectControlItems) {
      if (item.dueDate) {
        const d = new Date(item.dueDate);
        // force into local date only (year, month, day from UTC parts)
        item.dueDate = new Date(
          d.getUTCFullYear(),
          d.getUTCMonth(),
          d.getUTCDate()
        );
      }
    }

    for (i = 0; i < this.filteredProjectControlItems.length; i++) {
      if (this.filteredProjectControlItems[i].controlItem.parentControlItemId || this.projectControlItems.find(c => c.controlItem.controlItemId == this.filteredProjectControlItems[i].controlItem.parentControlItemId)) continue;
      if (this.assignedVendorUsers && this.assignedVendorUsers.find(u => this.projectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId].push(this.filteredProjectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.filteredProjectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.filteredProjectControlItems[i]);
        }
      }
      if (this.assignedNonVendorUsers && this.assignedNonVendorUsers.find(u => this.filteredProjectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId].push(this.filteredProjectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.filteredProjectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.filteredProjectControlItems[i]);
        }
      }
    }
    this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
    for (i = 0; i < this.assignedNonVendorUsers.length; i++) {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedNonVendorUsers[i].userId], this.assignedNonVendorUsers[i].userId);
    }
    for (i = 0; i < this.assignedVendorUsers.length; i++) {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedVendorUsers[i].userId], this.assignedVendorUsers[i].userId);
    }


  }

  updateRowGroupMetaData(data, key) {
    this.rowGroupMetadata[key] = {};
    console.log("|u");
    console.log(data);
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[key][brand] = {index: 0, size: 1, maturity: rowData.processMaturity};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[key][brand].maturity += rowData.processMaturity;
            this.rowGroupMetadata[key][brand].size++;
          } else
            this.rowGroupMetadata[key][brand] = {index: i, size: 1, maturity: rowData.processMaturity};
        }
      }
    }
  }

  onNodeRecurringChanged(event, value, projectControlItem: ProjectControlItem) {
    const newDate = projectControlItem.upcomingDueDate;

    projectControlItem.dueDate = moment(newDate).toDate();
    let ranges = DatesHelper.getDates(projectControlItem);
    const now = moment.utc();

    ranges = ranges.map(r => r.label);
    projectControlItem.completionPeriods = projectControlItem.completionPeriods.filter(d => ranges.filter(r => moment.utc(r).isSame(moment(r))).length > 0);

    projectControlItem.tenantName = LoginHelper.getTenantName();
    const savedSolutionDescription = projectControlItem.solutionDescription;
    projectControlItem.solutionDescription = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription || ''));
    const savedSolutionDescription2 = projectControlItem.solutionDescription2;
    projectControlItem.solutionDescription2 = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription2 || ''));
    const savedSolutionDescription3 = projectControlItem.solutionDescription3;
    projectControlItem.solutionDescription3 = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription3 || ''));


    this.projectControlItemService.update(projectControlItem.projectControlItemId, projectControlItem)
      .subscribe(
        data => {
          projectControlItem.solutionDescription = savedSolutionDescription;
          projectControlItem.solutionDescription2 = savedSolutionDescription2;
          projectControlItem.solutionDescription3 = savedSolutionDescription3;
          const upcomingDate = this.getUpcomingDate(projectControlItem).format('Y-MM-DDT00:00:00');
          projectControlItem.upcomingDueDate = upcomingDate;
          projectControlItem.previousDueDate = this.getPreviousDate(projectControlItem).format('Y-MM-DDT00:00:00');
          this.setCompleted(projectControlItem, upcomingDate);
          this.setReviewed(projectControlItem, upcomingDate);
          this.alertService.success('The "Frequency" value of the item was updated.', true);
          this.loadProject();
        },
        error => {
          projectControlItem.completionPeriods = projectControlItem.originalCompletionPeriods;


          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  onNodeDueDateChanged(type: string, event: MatDatepickerInputEvent<Date>, projectControlItem) {
    projectControlItem.tenantName = LoginHelper.getTenantName();
    const savedSolutionDescription = projectControlItem.solutionDescription;
    projectControlItem.solutionDescription = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription || ''));

    this.projectControlItemService.update(projectControlItem.projectControlItemId, projectControlItem)
      .subscribe(
        data => {
          projectControlItem.solutionDescription = savedSolutionDescription;
          const upcomingDate = this.getUpcomingDate(projectControlItem);
          this.setCompleted(projectControlItem, upcomingDate);
          //this.setReviewed(projectControlItem, upcomingDate);
          this.alertService.success('The "Start Date" value of the item was updated.', true);
          this.loadProject();
        },
        error => {
          projectControlItem.completionPeriods = projectControlItem.originalCompletionPeriods;


          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  public setCompleted(projectControlItem: ProjectControlItem, upcomingDate: Date | string | moment.Moment | null) {
    projectControlItem.completedItems = DatesHelper.getDates(projectControlItem);

    if (upcomingDate == null) {
      return;
    }
    const isCompleted = projectControlItem.completionPeriods.filter(x => moment(x.dueDate).isSame(upcomingDate + 'Z')).map(x => x.isCompleted)[0] || false;
    projectControlItem.currentRangeCompleted = isCompleted;
  }

  public setReviewed(projectControlItem: ProjectControlItem, upcomingDate: Date | moment.Moment | string | null) {
    projectControlItem.reviewedItems = DatesHelper.getDates(projectControlItem);

    if (upcomingDate == null) {
      return;
    }

    const isReviewedByConsultant = projectControlItem.reviewedByConsultantDates.map(x => moment(new Date(x))).find(x => x.isSame(upcomingDate + 'Z')) != null;
    projectControlItem.reviewedByConsultant = isReviewedByConsultant;
  }

  onNodeDateChanged(type: string, event: MatDatepickerInputEvent<Date>, projectControlItem: ProjectControlItem) {

    let originalDueDate = projectControlItem.dueDate;
    const newDate = new Date(event.value);
    const oldRanges = DatesHelper.getDates(projectControlItem, moment(event.value));
    const now = moment();

    projectControlItem.dueDate = newDate;
    const newRanges = DatesHelper.getDates(projectControlItem, moment(event.value));

    const futureOldRanges = oldRanges.filter(r => r.date.isAfter(now) && !newRanges.find(n => n.date.isSame(r.date)));

    const dropFuture = futureOldRanges.length && confirm("Do you want to drop the existing scheduled completion(s) on " + futureOldRanges.map(r => r.date.format('l')).join(", ") + "?");

    const newPeriods = newRanges.filter(r => !dropFuture || r.date.isBefore(now)).map(r => {
      const existing = projectControlItem.completionPeriods.find(i => moment(i.dueDate).isSame(r.value + 'Z'));
      if (existing) return existing;
      return <CompletionPeriod>{
        dueDate: r.value,
        completionPeriodId: 0,
        projectControlItemId: projectControlItem.projectControlItemId,
        actualDate: null,
        completedInRizkly: null,
        note: null,
        isCompleted: false
      };
    });
    const preservedPeriods = projectControlItem.completionPeriods.filter(r => !dropFuture || moment(r.dueDate).isBefore(now));
    projectControlItem.completionPeriods = preservedPeriods.concat(newPeriods);


    //this.onNodeRecurringChanged(type, projectControlItem.recurring, projectControlItem);

    projectControlItem.dueDate = newDate;
    projectControlItem.tenantName = LoginHelper.getTenantName();


    const savedSolutionDescription = projectControlItem.solutionDescription;
    projectControlItem.solutionDescription = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription || ''));

    this.projectControlItemService.update(projectControlItem.projectControlItemId, projectControlItem)
      .subscribe(
        data => {
          this.alertService.success('The due date of the item was updated.', true);

          this.loadProject();
          projectControlItem.solutionDescription = savedSolutionDescription;
          projectControlItem.completedItems = DatesHelper.getDates(projectControlItem);
          projectControlItem.upcomingDueDate = this.getUpcomingDate(projectControlItem).format('Y-MM-DDT00:00:00');
          projectControlItem.previousDueDate = this.getPreviousDate(projectControlItem).format('Y-MM-DDT00:00:00');
          projectControlItem.currentRangeCompleted = (projectControlItem.completionPeriods.find(i => moment(i.dueDate).isSame(projectControlItem.upcomingDueDate + 'Z')) || {isCompleted: false}).isCompleted;
        },
        error => {
          projectControlItem.dueDate = originalDueDate;
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  updateProjectControlItem(projectControlItem: ProjectControlItem) {
    projectControlItem.tenantName = LoginHelper.getTenantName();
    const savedSolutionDescription = projectControlItem.solutionDescription;
    projectControlItem.solutionDescription = fromByteArray(new TextEncoder().encode(projectControlItem.solutionDescription || ''));
    this.projectControlItemService.update(projectControlItem.projectControlItemId, projectControlItem)
      .subscribe(
        data => {
          this.alertService.success('Control item was updated.', true);
          projectControlItem.solutionDescription = savedSolutionDescription;
          (<any>projectControlItem).implementationStatusStyle = (projectControlItem.implementationControlStatusNotNeeded || projectControlItem.implementationStatus == ImplementationStatus.Implemented || projectControlItem.implementationStatus == ImplementationStatus.AlternativeImplementation) ? 'green' :
            (projectControlItem.implementationStatus == ImplementationStatus.PartiallyImplemented || projectControlItem.implementationStatus == ImplementationStatus.Planned) ? 'yellow' :
              projectControlItem.implementationStatus == ImplementationStatus.NotApplicable ? 'gray' : 'red';
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  public downloadEvidence(item: ProjectControlItem, fileName: string, isPath: boolean = false) {
    this.fileBlobService
      .downloadFile(isPath ? fileName.replace(/^.*[\\\/]/, '') : fileName, isPath ? fileName.replace(/[^\\/]*$/, '') : "Projects/" + this.project.name + (this.userMap[item.assignedClientId].role == Role.Vendor ? "/Vendors/" + encodeURIComponent(this.userMap[item.assignedClientId].emailAddress.replace('@', '_')) : '') + '/Evidence/' + item.shortFolderName)
      .subscribe(blob => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        error => {
          const errorMessage = 'An error occurred while downloading evidence.';
          this.alertService.error(errorMessage);
        });
  }

  filterUser(v) {
    return v.map(v => v.userId);
  }

  formatDate(v) {
    return moment(v).format('llll');
  }

  getFullName(user: User) {
    return StringsHelper.getFullName(user);
  }

  selectItem(item) {
    this.expandedCategories[item.controlItem.category] = true;
    let counter = 0;
    let parentOpen = false;
    const parent = this.projectControlItems.find(c => c.controlItem.controlItemId === item.controlItem.parentControlItemId);

    const waitInterval = setInterval(() => {
      if (counter === 10) {
        clearInterval(waitInterval);
      } else if (parent && !parentOpen && document.getElementById('cidrow' + parent.projectControlItemId)) {
        (<any>(document.querySelector('#cidrow' + parent.projectControlItemId + ' .fa-chevron-circle-right'))).click();
        parentOpen = true;
      } else if (document.getElementById('cidrow' + item.projectControlItemId)) {
        document.getElementById('cidrow' + item.projectControlItemId).scrollIntoView();
        (<any>document.querySelector('#cidrow' + item.projectControlItemId + ' td')).click();
        clearInterval(waitInterval);
      } else {
        counter++;
      }
    }, 100);
  }

  editControlItem(projectControlItemId: number, parent: ProjectControlItem, selectedTab: number = 0, selectedItem: number = 0) {
    let projectControlItem =
      this.project.projectControlItems.find(x => x.projectControlItemId == projectControlItemId);

    this.initialprojectControlItemId = 0;
    if (!projectControlItem) {
      this.alertService.error("Cannot open current item")
      return;
    }

    let config: MatDialogConfig = {
      width: '90%',
      height: '90%',
      data: {
        projectControlItem: projectControlItem,
        project: this.project,
        subItems: this.projectControlItems.filter(c => c.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId),
        selectedTab,
        selectedItem
      }
    };
    const dialogRef = this.dialog.open(ProjectControlItemComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.alertService.clear()
        this.loadProject();
      }
    });
  }

  openAccessRightsPopup() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '40%',
      height: '600px',

      data: {
        project: this.project
      }
    };

    let dialogAccessRightsRef = this.dialog.open(ProjectAccessRightsComponent, config);

    dialogAccessRightsRef.afterClosed().subscribe((result: any) => {
      this.loadProject();
    });
  }

  generateActionPlan() {

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: 'auto',

      data: {
        project: this.project
      }
    };

    /*if (!this.project.clientITProfileIds || this.project.clientITProfileIds.length == 0) {
      this.dialog.open(MessageComponent, {data: {title: '', text: 'IT Profile not selected', button: 'Close'}})
    } else */{
      this.dialog.open(GenerateSspComponent, config);
    }
  }

  generateCRM() {

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: 'auto',

      data: {
        project: this.project
      }
    };

    if (!this.project.clientITProfileIds || this.project.clientITProfileIds.length == 0) {
      this.dialog.open(MessageComponent, {data: {title: '', text: 'IT Profile not selected', button: 'Close'}})
    } else if (this.project.clientITProfileIds.length === 1) {
      this.projectService.downloadCRM(this.project.projectId, this.project.clientITProfileIds[0]).subscribe(blob => {
          importedSaveAs(new Blob([blob]), 'CRM.xlsx');
        },
        error => {
          const errorMessage = 'Error during generation CRM';
          this.alertService.error(errorMessage);
        });
    } else {
      this.dialog.open(GenerateCrmComponent, config);
    }
  }

  onPoamView() {

    this.router.navigate(['/projects/poam/' + this.project.projectId]);
  }

  editProject() {

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '90%',
      height: '90%',

      data: {
        project: this.project
      }
    };

    let dialogProjectRef = this.dialog.open(ProjectPropertiesComponent, config);

    dialogProjectRef.afterClosed().subscribe((result: any) => {
      this.alertService.clear();
      if (result !== false) {
        this.loadProject();
      }
    }, () => this.alertService.clear());
  }

  onPanelHide() {
    /*var row = (<any>this.table).tableViewChild.nativeElement.children[0].children[0];
    var width = row.clientWidth;
    var sizes = [];
    for (var i = 0; i < row.children.length - 2; i++) {
      sizes.push(row.children[i].clientWidth / width * 100 + '%');
    }*/
    this.columnVisibility = {};
    this.cols.sort((a, b) => this.columnOptions.indexOf(this.columnOptions.find(c => c.value == a)) - this.columnOptions.indexOf((this.columnOptions.find((c => c.value == b)))));
    for (let i = 0; i < this.columnOptions.length; i++) {
      if (!this.cols.find(c => c.field == this.columnOptions[i].value.field)) {
        this.columnVisibility[this.columnOptions[i].value.field] = false;
      }
    }
    this.clientProfileService.saveUserSetting("ProjectTableNew", {columnVisibility: this.columnVisibility}).subscribe(() => {
    });
  }

  toggleItems() {
    const opened = document.querySelectorAll(".fa-chevron-circle-down");
    const closed = document.querySelectorAll(".fa-chevron-circle-right");
    if (closed.length == 0) {
      Array.from(opened).forEach(i => (i as any).click());
    } else {
      Array.from(closed).forEach(i => (i as any).click());
    }
  }

  showScoringReport() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '60%',
      height: '600px',

      data: {
        project: this.project
      }
    };

    const dialogRef = this.dialog.open(ScoringReportComponent, config);
  }

  filterItems() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.filteredProjectControlItems = this.projectControlItems.filter(i => (i.controlItem.description || "").toLowerCase().includes(this.filter.toLowerCase()) || (i.controlItem.shortName || "").toLowerCase().includes(this.filter.toLowerCase()) || (i.controlItem.complianceAreaControlId || "").toLowerCase().includes(this.filter.toLowerCase())
        || (i.controlItem.category || "").toLowerCase().includes(this.filter.toLowerCase())
        || (i.controlItem.supplementalGuidance || "").toLowerCase().includes(this.filter.toLowerCase())
        || (i.controlItem.scoringGuidance || "").toLowerCase().includes(this.filter.toLowerCase())
        || (i.controlItem.practiceGuidance || "").toLowerCase().includes(this.filter.toLowerCase())
        || (i.attachments || []).find(a => a.name.toLowerCase().includes(this.filter.toLowerCase()))
        || (i.subItems || []).find(s =>
          (s.controlItem.complianceAreaControlId || "").toLowerCase().includes(this.filter.toLowerCase())));
      this.regroupControlItems();
    }, 250);
  }

  public uploadProjectData(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.projectService.uploadProjectData(file, this.project.projectId).subscribe(
        (res) => {
          const errorMessage = 'The control items were uploaded.';
          this.alertService.success(errorMessage);
          this.loadProject();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  public uploadPoamData(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.projectService.uploadPoamData(file, this.project.projectId).subscribe(
        (res) => {
          const errorMessage = 'The POA&Ms were uploaded.';
          this.alertService.success(errorMessage);
          this.loadProject();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload POA&Ms.';
          this.alertService.error(errorMessage);
        });
    }
  }

  clickOnWorkstreamDot(controlItemId) {
    this.router.navigate(['/workstreams'], { queryParams: { controlItemId } });
  }

  isItemOverdue(workstream) {
    const currentDate = new Date();
    return (workstream.status !== "Dev Complete" &&  workstream.status !== "Deployed" && currentDate > new Date(workstream.dueDate));
  }

  openSendMessage(projectControlItem) {
    let config: MatDialogConfig = {
      width: '300px',
      height: 'auto',
      data: {
        projectControlItemId: projectControlItem.projectControlItemId,
      }
    };
    const dialogRef = this.dialog.open(SendProjectControlItemMessageComponent, config);
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateScore(projectControlItem){
    projectControlItem.dynamicScore =
      (projectControlItem.solutionDescription || projectControlItem.solutionDescription2 || projectControlItem.solutionDescription3 ? this.settings.implementationStatusScore : 0) +
      (projectControlItem.evidences.length ? this.settings.evidenceScore : 0) +
      (projectControlItem.policies.length ? this.settings.policyScore : 0) +
      (projectControlItem.actionPlans.find(a => a.status !== 'Resolved') ? 0 : this.settings.poamScore);
  }


  protected readonly encodeURIComponent = encodeURIComponent;
}
